var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.91484C1.07491 3.69598 1.11901 3.45917 1.23067 3.26107C1.56286 2.6724 2.08301 2.37155 2.75718 2.36733C3.76844 2.36064 4.78004 2.36451 5.79165 2.36592C6.02722 2.36627 6.18544 2.50878 6.18719 2.71181C6.18929 2.91659 6.02232 3.06332 5.7829 3.06367C4.78949 3.06438 3.79644 3.06262 2.80304 3.06438C2.26153 3.06543 1.86809 3.35959 1.73333 3.86734C1.70567 3.97184 1.69832 4.08444 1.69832 4.19316C1.69657 7.18403 1.69622 10.1745 1.69762 13.1654C1.69762 13.7256 1.9766 14.1179 2.474 14.2565C2.58637 14.2879 2.70748 14.3002 2.82439 14.3002C6.03177 14.3023 9.23951 14.3023 12.4469 14.3016C13.1291 14.3016 13.5719 13.8522 13.573 13.1626C13.5744 12.1689 13.573 11.1749 13.5737 10.1809C13.5737 9.98101 13.6776 9.83428 13.8393 9.79769C14.0522 9.74984 14.2573 9.90395 14.2632 10.1281C14.2706 10.4071 14.2664 10.6869 14.266 10.9662C14.265 11.7586 14.2755 12.551 14.2587 13.3431C14.2401 14.2192 13.4988 14.9557 12.6268 14.9933C12.5631 14.9962 12.4994 14.9986 12.4357 14.9986C9.23286 14.9986 6.02967 14.9976 2.82684 15C2.12502 15.0007 1.58036 14.7175 1.23137 14.1045C1.11901 13.9075 1.07526 13.6707 1 13.4518C1 10.2727 1 7.09395 1 3.91484Z",
    fill: "url(#paint0_linear_5471_19140)",
    stroke: "url(#paint1_linear_5471_19140)",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0309 1C13.4198 1.00774 13.7726 1.13512 14.0677 1.40605C14.2291 1.55419 14.3827 1.71112 14.5346 1.86911C15.1441 2.50353 15.1563 3.4219 14.5662 4.07426C14.5294 4.11472 14.4909 4.15378 14.452 4.19284C12.4418 6.2136 10.4308 8.23402 8.42266 10.2569C8.30925 10.3713 8.18394 10.4441 8.02922 10.4863C7.12088 10.7351 6.21428 10.9902 5.30734 11.2439C5.18657 11.2777 5.06861 11.3019 4.95065 11.2337C4.80503 11.1489 4.74483 10.9962 4.79663 10.8065C5.01051 10.0215 5.24713 9.24247 5.43475 8.45112C5.54676 7.97751 5.77604 7.61474 6.11942 7.27378C8.03867 5.36877 9.94077 3.44618 11.8457 1.52674C12.1733 1.19669 12.5555 1.00739 13.0316 1.00035L13.0309 1ZM11.5523 2.87123C9.86936 4.563 8.17694 6.26427 6.49781 7.95253C7.02427 8.48173 7.56437 9.02466 8.08313 9.54648C9.76645 7.85436 11.4589 6.15308 13.1387 4.46448C12.6122 3.93562 12.0718 3.39269 11.5523 2.87123ZM12.0368 2.29839C12.6017 2.867 13.1436 3.4124 13.7009 3.97362C13.8003 3.86841 13.907 3.75652 14.0124 3.64322C14.0558 3.59642 14.0989 3.54892 14.1367 3.49755C14.3537 3.2062 14.361 2.75405 14.1272 2.47573C13.949 2.26355 13.7534 2.06123 13.5405 1.8853C13.2717 1.66362 12.9465 1.62703 12.6476 1.8005C12.4208 1.93245 12.2339 2.13407 12.0368 2.29839ZM6.11872 8.62354C5.9549 9.21889 5.79214 9.81144 5.62272 10.4272C6.23598 10.2562 6.82545 10.0915 7.41526 9.92685C6.97876 9.48807 6.55487 9.06161 6.11872 8.62354Z",
    fill: "url(#paint2_linear_5471_19140)",
    stroke: "url(#paint3_linear_5471_19140)",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5471_19140",
    x1: 1.38663,
    y1: 2.77735,
    x2: 1.38663,
    y2: 14.6774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#406EE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#406EE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5471_19140",
    x1: 1.38663,
    y1: 2.77735,
    x2: 1.38663,
    y2: 14.6774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#406EE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#406EE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5471_19140",
    x1: 5.07619,
    y1: 1.33656,
    x2: 5.07619,
    y2: 11.0148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#406EE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#406EE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5471_19140",
    x1: 5.07619,
    y1: 1.33656,
    x2: 5.07619,
    y2: 11.0148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#406EE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#406EE2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPin);
export default __webpack_public_path__ + "static/media/edit_pin.82639fa4f2d3c8734418df50e4e81d6b.svg";
export { ForwardRef as ReactComponent };